import API from "../Services/API";
import Model from "./Model";

const useSettings = (path, savedMessage) => {
    return Model({
        alwaysRefresh: true,
        stateKey: ['settings', path],
        fetchData: () => API.get(path),
        returnDataKey: 'settings',
        registerAdditionalMethods: (opts) => {
            return {
                update: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(path, data),
                        savedMessage ?? 'Settings saved',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Failed to load settings.',
    });
}

export {
    useSettings,
}